import eventEmitter from 'event-emitter';
export default new eventEmitter();
